<template>
  <DashboardVideo />
  <div
    class="container h-100 d-flex align-items-unset justify-content-center z-2"
  >
    <div class="row mobile align-content-unset g-0">
      <div
        class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-end theme-header"
      >
        <a
          href="https://test.metaluxe.com.au/"
          target="_blank"
          class="annotation"
          data-bs-toggle="tooltip"
          title="Click to Edits"
        >
          <img src="/img/ui-theme/annotation-red.svg"
        /></a>

        <a href="#" class="m-auto"
          ><img :src="`/img/ui-theme/` + theme.devLogo" class="devlogo"
        /></a>
        <button
          class="btn"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
          style="padding-right: 0; padding-left: 0"
        >
          <img src="/img/ui-theme/contact-icon-rev.svg" alt="Fullscreen" />
        </button>
      </div>
      <div class="col-12 d-flex align-items-unset justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <router-link
              v-if="assetTypes"
              :to="{
                name: 'VideoView',
                params: {
                  guid: '1b65850c-db35-4fae-96da-813c2fe5a5be',
                  collectionId: '598869',
                },
              }"
              class="border-top-right-radius btn-theme-menu mb-2 flex"
            >
              <img
                :src="theme['cinematicsIcon']"
                alt="videos"
                :class="['ms-4', 'video-icon']"
                style="margin-right: 1.5rem"
              />
              <span className="video-label flex-1 ">Cinematics</span>
            </router-link>

            <div
              v-for="(assetType, key) in assetTypes?.filter(
                (item) => item.ObjectName !== 'Margaret Ave'
              )"
              :key="assetType.Guid"
            >
              <!-- <router-link
                :to="{
                  name: componentName,
                  params: {
                    assetType: assetType.LinkName,
                  },
                }"
                :class="[
                  key === 0 ? 'border-top-right-radius' : '',
                  'btn-theme-menu',
                  'mb-2',
                ]"
              >
                <img
                  :src="theme[assetType.LinkName + 'Icon']"
                  alt="videos"
                  :class="[
                    assetType.ObjectName === 'Cinematics' ? 'ms-4 ' : 'me-3',
                    'video-icon',
                  ]"
                  style="margin-right: 1.5rem"
                />
                <span className="video-label">{{ assetType.ObjectName }}</span>
              </router-link> -->
              <router-link
                v-if="assetType.ObjectName === 'Cinematics'"
                :to="{
                  name: 'AssetView',
                  params: {
                    assetType: 'margaret-ave',
                    viewType: 'renders',
                    order: 0,
                  },
                }"
                class="btn-theme-menu mb-2"
              >
                <img
                  :src="theme.rendersIcon"
                  alt="renders"
                  style="margin-right: 1.5rem"
                />
                <span className="video-label">Renders</span>
              </router-link>
            </div>

            <router-link
              v-if="this.assetTypes"
              :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: 'margaret-ave',
                  viewType: 'birds-eye-view',
                  order: 0,
                },
              }"
              class="btn-theme-menu mb-2"
            >
              <div class="flex" style="width: 210px">
                <img
                  :src="theme.panoramasIcon"
                  alt="virtual-tour"
                  style="margin-right: 33px; margin-left: 27px"
                />
                <span className="video-label">Birds Eye View</span>
              </div>
            </router-link>
            <router-link
              v-if="this.assetTypes"
              :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: 'margaret-ave',
                  viewType: 'level-19',
                  order: 0,
                },
              }"
              class="btn-theme-menu mb-2 border-bottom-left-radius"
            >
              <div class="flex" style="width: 210px">
                <img
                  :src="theme.panoramasIcon"
                  alt="virtual-tour"
                  class="video-icon"
                  style="margin-right: 33px; margin-left: 27px"
                />
                <span className="video-label">Level 19</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <OffCanvas /> -->
</template>

<script>
import DashboardVideo from '@/components/DashboardVideo.vue'
import OffCanvas from '@/components/OffCanvas.vue'
import global from '../global'
import BunnyNetService from '@/services/BunnyNetService.js'
import { unslugify } from 'unslugify'
import sortArray from 'sort-array'

export default {
  name: 'DashboardHome',
  components: {
    DashboardVideo,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      componentName: 'AssetType',
      componentAdmin: 'Admin',
      folderStructure: encodeURIComponent(this.theme.devFolder + '/assets/'),
      brochureUrl: '',
    }
  },
  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          }
        })

        const customMenu = sortArray(menuItems, {
          by: ['LinkName'],
          order: 'LinkName',
          customOrders: {
            LinkName: this.theme.assetsMenuOrder,
          },
        })
        this.assetTypes = customMenu
      })
      .catch((error) => {
        console.log(error)
      })
  },
  setup() {
    const { theme } = global

    return {
      theme,
    }
  },
}
</script>
